import type { PopphinSaveSystem } from "./PopphinSaveSystem";

/**
 * Codex manager — reads save state to know which creatures the player has unlocked.
 * No sibling manager imports — pulls only from save state.
 */
export class CodexManager {
  constructor(private readonly save: PopphinSaveSystem) {}

  async unlockedIds(): Promise<string[]> {
    const state = await this.save.load();
    return state.unlockedCreatures;
  }

  async progress(): Promise<{ unlocked: number; total: number }> {
    const state = await this.save.load();
    return { unlocked: state.unlockedCreatures.length, total: 30 };
  }
}
